import React from "react";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTag, faUser } from "@fortawesome/pro-solid-svg-icons";

import { KIOSK_COMMUNICATION_EVENT_TYPES } from "../../../../../../util/communication_statuses";
import { getEventName } from "../../util";

import "./index.scss";

const CommunicationEvents = ({ events, comm, t }) => {
  return (
    <div className="kiosk-comm-events">
      {events.map((event, index) => {
        const customerFullname =
          event.type === KIOSK_COMMUNICATION_EVENT_TYPES.CHECK_IN_OPENED && comm.customer ? `${comm.customer.firstname || ""} ${comm.customer.surname || ""}`.trim() : "";

        const userFullname =
          event.type === KIOSK_COMMUNICATION_EVENT_TYPES.LABEL_DETACHED && event.user ? `${event.user.first_name || ""} ${event.user.last_name || ""}`.trim() : "";

        const isAnswered = event.type === KIOSK_COMMUNICATION_EVENT_TYPES.CHECK_IN_ANSWERED;
        const answeredCommunicationData = isAnswered && (event.kiosk_label_number || event.kiosk_name);

        return (
          <div className="kiosk-comm-event-row" key={event.id || index}>
            <div className="kiosk-comm-event-line">
              <span className="kiosk-comm-event-name">{getEventName(event, t)}</span>
              <span className="kiosk-comm-event-time">
                {moment(event.created_on).format("HH:mm")} - {moment(event.created_on).format("DD-MM-YYYY")}
              </span>
            </div>

            {(customerFullname || userFullname || answeredCommunicationData) && (
              <div className="kiosk-comm-event-meta">
                {answeredCommunicationData && (
                  <span className="kiosk-comm-event-field">
                    {event.kiosk_label_number && (
                      <span className="kiosk-comm-event-chip">
                        <FontAwesomeIcon icon={faTag} />
                        <span>{event.kiosk_label_number}</span>
                      </span>
                    )}
                    {event.kiosk_name && <span>{event.kiosk_name}</span>}
                  </span>
                )}

                {userFullname && (
                  <span className="kiosk-comm-event-field">
                    <FontAwesomeIcon icon={faUser} className="i-green" />
                    <span>{userFullname}</span>
                  </span>
                )}

                {customerFullname && (
                  <span className="kiosk-comm-event-field">
                    <FontAwesomeIcon icon={faUser} className="i-green" />
                    <span>{customerFullname}</span>
                  </span>
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default CommunicationEvents;
